module.exports = __webpack_public_path__ + "img/11-unbind-relation.9d0f89fb.png";